import React, { Component, createContext } from "react";
import MemberNavigationTabs from "../../../components/NavigationTabs/MemberNavigationTabs";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import MemberInfo from "./Pages/MemberInfo";
import connect from "react-redux/es/connect/connect";
import ls from 'localstorage-slim';
import MemberCards from "./Pages/MemberCards";
import MemberTickets from "./Pages/MemberTickets";
import queryString from "query-string";
import axios from "../../../axios-instance";
import styles from './SeasonPassPersonalInfo.module.sass';
import { getLangCode, setLangCode } from "../../../constants/seasonPassPersonalInfoLangs";

export const MemberPageContext = createContext({});

class MemberPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFramed: false,
            token: '',
            isMemberFound: true,
            lang: this.props.match.params.lang || getLangCode(),
        }
    }

    handleLang = (lang) => {
        const acceptedLangs = ['en', 'rs'];
        if (!lang || !acceptedLangs.some((key) => key === lang)) {
            setLangCode('rs');
            return;
        }

        setLangCode(lang);
    };

    handleChangeLang = (lang) => {
      this.setState({lang: lang.value});
      this.handleLang(lang.value);

      const queryParams = new URLSearchParams(window.location.search);

      queryParams.set('lang', lang.value);
      window.history.replaceState(null, null, "?" + queryParams.toString());
    }

    handleChangeMemberFound = (result) => {
        if (result) {
            ls.set('isRefreshed', false);
        }
        this.setState({ isMemberFound: result });
    }

    loadSeasonPassMember = async () => {
        const token = ls.get('member-access-token');
        await axios
            .get(`/SeasonPassMember?accessToken=${token}`)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    this.setState({
                        userData: {
                            firstName: response.data.firstName,
                            lastName: response.data.lastName,
                            email: response.data.email,
                            phone: response.data.phoneNumber,
                            gender: response.data.gender,
                            physicalAddress: response.data.physicalAddress,
                            city: response.data.city,
                            postalCode: response.data.postalCode,
                            points: response.data.points,
                            pendingToApprove: response.data.status === 2,
                            memberStatus: response.data.status,
                            dateOfBirth: response.data.dateOfBirth && response.data.dateOfBirth !== "0001-01-01T00:00:00"
                                ? response.data.dateOfBirth
                                : null,
                        }
                    });

                    localStorage.setItem('user_' + response.data.email.toLowerCase().trim(), token);

                    return;
                }

                throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
            });
    };

    componentDidMount() {
        const { params } = this.props.match;
        
        const framed = window.location.pathname.includes('cfmember') || window.location.pathname.includes('efmember');
        this.setState({ isFramed: framed });

        const pageAction = queryString.parse(window.location.search).action;

        if (pageAction === 'selling' && !ls.get('pageAction')) {
            ls.set('pageAction', 'selling', {
                ttl: 60 * 60 * 12
            });
        }

        this.setState({ token: params.accessToken });
        var oldToken = ls.get('member-access-token', '');
        ls.set('member-access-token', params.accessToken);

        if (oldToken !== params.accessToken) {
            window.location.reload();
        }

        this.handleLang(this.state.lang);

        this.loadSeasonPassMember();
    }
    

    render() {
        const { isMemberFound, lang, isFramed } = this.state;

        if (!isMemberFound) {
            var isRefreshed = ls.get('isRefreshed');
            console.log(isRefreshed);
            if (!isRefreshed) {
                const { params } = this.props.match;

                this.setState({ token: params.accessToken });
                ls.set('member-access-token', params.accessToken);
                ls.set('isRefreshed', true);
                window.location.reload();
            }
            // return <Page404 isBackBtn={false} isRefreshAvailable={true} />;
        }

        return <>
            <section className={styles['member-page']}>
                {!isFramed && 
                    <div className={styles['member-page__nav-wrapper']}>
                    <div className={styles['member-page__nav']}>
                        <MemberNavigationTabs isSaleMode={ls.get('pageAction') === 'selling'} disableSaleModeHandler={() => { ls.remove('pageAction'); window.location.reload() }} />
                    </div>
                    </div>
                }

                <MemberPageContext.Provider value={this.state} >

                    <Switch>
                        <Redirect
                            from={ROUTES.MEMBER_NEW}
                            to={ROUTES.MEMBER_NEW_INFO}
                            exact
                        />
                        <Route
                            path={ROUTES.MEMBER_NEW_CARDS_FRAME}
                            exact
                            render={(props) => <MemberCards {...props} isFramed={isFramed} handleChangeMemberFound={this.handleChangeMemberFound} lang={lang} handleChangeLang={this.handleChangeLang} />}
                        />
                        <Route
                            path={ROUTES.MEMBER_NEW_EVENTS_FRAME}
                            exact
                            render={(props) => <MemberTickets {...props} isFramed={isFramed} handleChangeMemberFound={this.handleChangeMemberFound} lang={lang} handleChangeLang={this.handleChangeLang} />}
                        />

                        <Route
                            path={ROUTES.MEMBER_NEW_INFO}
                            exact
                            render={(props) => <MemberInfo {...props} handleChangeMemberFound={this.handleChangeMemberFound} lang={lang} handleChangeLang={this.handleChangeLang} />}
                        />

                        <Route
                            path={ROUTES.MEMBER_NEW_CARDS}
                            exact
                            render={(props) => <MemberCards {...props} lang={lang} handleChangeLang={this.handleChangeLang} />}
                        />

                        <Route
                            path={ROUTES.MEMBER_NEW_EVENTS}
                            exact
                            render={(props) => <MemberTickets {...props} lang={lang} handleChangeLang={this.handleChangeLang} />}
                        />
                    </Switch>
                </MemberPageContext.Provider>

            </section >
        </>
    }
}

const mapStateToProps = ({
    auth: { user },
    events: { currentEvent, loading, error, currentTicket },
}) => ({ user, currentEvent, loading, error, currentTicket });

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MemberPage));